import React, { useState } from 'react'
import { SelectFieldGroup } from './FormFields'
import type { CommonProps } from './FormFields'
import type { Props as ReactSelectProps } from 'react-select'
import type { ServiceStatus } from '../../../models/enums'

type StatusSelectProps = Omit<ReactSelectProps, 'options' | 'isDisabled'> & CommonProps & { optionsList?: ServiceStatus[], readableSeperator?: string}

const StatusSelect: React.FC<StatusSelectProps> = ({ optionsList, readableSeperator = '', ...props }) => {
    const [options] = useState<ServiceStatus[]>(optionsList && optionsList.length > 0 ? optionsList : ['Active', 'Inactive', 'InactiveCompleted', 'InactiveRescinded', 'InactiveDenied', 'Draft'])

    return <SelectFieldGroup {...props} options={options} readableSeperator={readableSeperator} />
}

export default StatusSelect
